import React from 'react'
import PropTypes from 'prop-types'
import { Select } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

/**
 * Used on artifact pages to filter artifacts by their category
 */
const CategoryFilter = ({ value, onChange }) => {
  const [t] = useTranslation()
  return (
    <Select
      hidePlaceholder
      autoWidth
      label={t('category', 'Category')}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      name="categoryFilter"
      options={[
        {
          value: 'any',
          label: t('artifacts.category.all', 'All'),
        },
        {
          value: 'image',
          label: t('artifacts.category.images', 'Images'),
        },
        {
          value: 'audio',
          label: t('person.entityRef.audio', 'Audio'),
        },
        {
          value: 'pdf',
          label: t('artifacts.category.pdfs', 'PDFs'),
        },
        {
          value: 'text',
          label: t('artifacts.category.stories', 'Stories'),
        },
      ]}
    />
  )
}

CategoryFilter.propTypes = {
  value: PropTypes.oneOf(['any', 'image', 'audio', 'pdf', 'text']).isRequired,
  // This callback will be passed a string: oneOf(['any', 'image', 'audio', 'pdf', 'text'])
  onChange: PropTypes.func.isRequired,
}

export default CategoryFilter
